import { Outlet, useLocation } from 'react-router-dom';
import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { AppSidebar } from "./app-sidebar";
import { SiteHeader } from "./site-header";
import { ConfigProvider, useConfig } from "../contexts/config-context";
import { ConfigSidebar } from "./config-sidebar";
import { ChangePasswordModal } from "./change-password-form";
import { useUserStore } from "../stores/userStore";

function DashboardShell() {
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const { isConfigOpen, isGeneratorPage } = useConfig();
  const user = useUserStore((state) => state.user);
  const location = useLocation();

  // No padding for generator page
  const isGeneratorRoute = location.pathname === '/generator';

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 250,
        breakpoint: 'sm',
        collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
      }}
      aside={{
        width: 300,
        breakpoint: 'md',
        collapsed: { desktop: !isConfigOpen || !isGeneratorPage, mobile: !isConfigOpen || !isGeneratorPage },
      }}
      padding={isGeneratorRoute ? 0 : "md"}
    >
      <AppShell.Header>
        <SiteHeader 
            mobileOpened={mobileOpened} 
            toggleMobile={toggleMobile} 
            desktopOpened={desktopOpened}
            toggleDesktop={toggleDesktop}
        />
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <AppSidebar />
      </AppShell.Navbar>

      <AppShell.Aside p={0}>
         <ConfigSidebar />
      </AppShell.Aside>

      <AppShell.Main style={{ height: 'calc(100vh - 60px)', overflowY: 'auto' }}>
        <Outlet />
      </AppShell.Main>
      
      <ChangePasswordModal
        open={user?.mustChangePassword}
        mustChange={user?.mustChangePassword}
      />
    </AppShell>
  );
}

export function DashboardLayout() {
  return (
    <ConfigProvider>
      <DashboardShell />
    </ConfigProvider>
  );
}